import { useEffect, useState } from 'react';

// const baseUrl = "http://localhost:3001" //DEV
const baseUrl = 'https://cwc-backend-heroku.herokuapp.com'; //PRODUCTION

const useFetchImages = (token, upc) => {
	const [errorImg, setErrorImg] = useState(null);
	const [loadingImages, setLoadingImages] = useState(false);
	const [images, setImages] = useState(null);

	const fetchImgData = async (upc) => {
		if (!upc) {
			return;
		}
		//reset the data and loading
		setLoadingImages(true);
		setImages(null);
		const options = {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		};
		const url = `${baseUrl}/inventory/images/${upc}`;
		try {
			const response = await fetch(url, options);
			const parsedResp = await response.json();
			const images = parsedResp.data;
			console.log('[*] API Response:', images);
			setImages(images);
			setLoadingImages(false);
		} catch (errorImg) {
			setErrorImg(errorImg);
			return console.error(errorImg);
		}
	};

	useEffect(() => {
		if (!token || !upc) return;

		fetchImgData(upc);
	}, [token, upc]);

	return { errorImg, loadingImages, images, fetchImgData };
};

export default useFetchImages;
